<template>

    <div class="column">
        <table>
            <tr v-for="(item, i) in items" :key="i" class="hover">
                <td class="bold fit" style="font-family: monospace; font-size: 12px;">{{ item.k }}</td>
                
                <td v-if="!item.list" class="t6" style="font-family: monospace;font-size: 12px; word-break: break-all;">{{ item.v }}</td>

                <td v-else class="t6" style="font-family: monospace;font-size: 12px;  word-break: break-all;padding: 0;">
                    
                    <table  v-if="item.list" style="margin: 0;padding: 0;border: none;">
                        <tr style="margin: 0;padding: 0;border: none" v-for="(sub, index2) in item.list" :key="index2">
                            <td class="t6 fit" style="font-family: monospace;font-size: 12px; white-space: nowrap;">{{ sub.k }}</td>
                            <td class="t6" style="font-family: monospace;font-size: 12px; word-break: break-all;">{{ sub.v }}</td>
                        </tr>
                    </table>    

                </td>
                
            </tr>
        </table>
    </div>

<!-- 
    <JJ :raw="account"></JJ>
 -->
</template>
<script>
    
export default {
    data: function () {return {
        
    }},
    props:{
        raw:undefined,         
    },    
    
    computed: {
        items(){
            let map = this.raw
            if (!map) return []
            return this.tools.json2array(this.raw)
            

            // let res = [] //{title, k,v}, {k, list}            
            // let data = this.raw
            // console.log(typeof data)

            // switch (typeof data) {
            //     case 'object':
            //         for (var k in data){
            //             let v = data[k]
            //             res.push({k,v})
            //         }
            //         break;
            //     case 'array':                     
            //         data.forEach(item => {
            //             res.push({k:item})
            //         });    
            //     break;            
            //     default:
            //         break;
            // }

            // return res
        },        
    },

    methods: {
    //  
    },
}
</script>
<style scoped>

</style>




















